import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@base/environments/environment';
import { HttpService } from '../core/http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPasswordService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/configuration/user/changePassword';
    this.baseUrl = environment.apiEndpoint;
  }

  async changePassword(
    oldPass: string,
    newPass: string,
    repetNewPass: string
  ): Promise<any> {
    const body = `oldPass=${oldPass}&newPass=${newPass}&repeatNewPass=${repetNewPass}`;
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded; charset=UTF-8'
    );

    try {
      const response = await firstValueFrom(
        this.http.post(
          environment.oldFrontUrl + '/configuracion/password/change',
          body,
          { headers }
        )
      );
      return JSON.parse(JSON.stringify(response));
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
